import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import AllianceConfirm from './components/AllianceConfirm';
import AllianceView from './components/AllianceView';
import AllianceServices from './services/AllianceServices';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';
import SnackbarAlert from 'ui-component/Alerts/SnackbarAlerts';

export const AlliancePage = () => {
  const { user } = useSelector((state) => state.user);
  const [canWatch, setCanWatch] = useState(false);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [snackbarData, setSnackbarData] = useState({
    open: false,
    severity: 'success',
    message: '',
    duration: 3000
  });

  useEffect(() => {
    const handleConfirm = async () => {
      try {
        setLoading(true);
        const check = await AllianceServices.checkAlliancForUser(user?.uid);
        setCanWatch(check?.exists);
      } catch (error) {
        console.error('🚀 ~ useEffect ~ error:', error);
      } finally {
        setLoading(false);
      }
    };

    handleConfirm();
  }, [user, reload]);

  const handleReload = () => setReload((prev) => !prev);

  const openSnackbar = (message, severity = 'success') => {
    setSnackbarData({
      ...snackbarData,
      open: true,
      severity,
      message
    });
  };

  const closeSnackbar = () => {
    setSnackbarData({
      ...snackbarData,
      open: false
    });
  };

  return (
    <>
      {loading ? (
        <SkeletonPopularCard />
      ) : canWatch ? (
        <AllianceView />
      ) : (
        <AllianceConfirm openSnackbar={openSnackbar} handleReload={handleReload} />
      )}
      <SnackbarAlert {...snackbarData} closeSnackbar={closeSnackbar} />
    </>
  );
};
